export default function AviatorRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    center h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 18px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 920px;
                        max-height: 100vh;
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                `}
            </style>

            <div class="modal fade show" id="modalMarketRules" tabindex="-1" role="dialog" aria-labelledby="modalMarketRules" style={{ display: "block" }}>
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>Aviator</b></h1>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20"><b>1.</b> Place your bets before takeoff.</p>
                                            <p class="pt20"><b>2.</b> Users can not cancel their bets after takeoff.</p>
                                            <p class="pt20"><b>3.</b> Any bets placed after takeoff will be placed in the next round.</p>
                                            <p class="pt20"><b>4.</b> Cashouts can only be done for active bets while the flight is still in air.</p>
                                            <p class="pt20 notice" style={{ color: "red" }}>
                                                A good internet connection is required to play Aviator.
                                                If players are unable to cashout due to a poor internet connection,
                                                the bet will be settled as lost.
                                            </p>
                                        </div>
                                    </center>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}